module.exports = __webpack_public_path__ + "assets/img/right@2x.8b6591f7.svg";